import styled from 'styled-components';
import { FormGroup } from './FormGroup';

export const FullWidthGroup = styled(FormGroup)`
  grid-column: ${({ $gridColumn }) => $gridColumn || '1 / span 2'};
`;